<div
    *ngIf="!disabled && !(files?.length > 0)"
    class="drop-zone drop-zone--full"
    [class.drag-over]="isDragOver"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="fileInput.click()"
    (keyup.enter)="fileInput.click()"
    tabindex="0"
    role="button"
>
    <app-spinner *ngIf="uploading; else uploadContent" size="s3" />
    <ng-template #uploadContent>
        <span class="material-symbols-rounded" aria-hidden="true">cloud_upload</span>
        <p>{{ 'FEATURES.AGREEMENTS.UPLOAD_ATTACHMENT' | translate }}</p>
        <p class="drop-hint">{{ 'FEATURES.AGREEMENTS.UPLOAD_CONTRACT_DRAG_FROP_AREA' | translate }}</p>
    </ng-template>
    <input
        type="file"
        (click)="resetFileUpload($event)"
        (change)="uploadFile($event)"
        [multiple]="false"
        [disabled]="uploading"
        style="display: none"
        #fileInput
    />
</div>

<form *ngIf="files?.length > 0">
    <app-form-section [formGroup]="attachmentForm">
        <app-form-row>
            <app-form-group class="report-container">
                <div
                    *ngIf="!disabled"
                    class="drop-zone"
                    [class.drag-over]="isDragOver"
                    (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event)"
                    (click)="fileInput.click()"
                    (keyup.enter)="fileInput.click()"
                    tabindex="0"
                    role="button"
                >
                    <app-spinner *ngIf="uploading; else uploadContent" size="s3" />
                    <ng-template #uploadContent>
                        <span class="material-symbols-rounded" aria-hidden="true">cloud_upload</span>
                        <p>{{ 'FEATURES.AGREEMENTS.UPLOAD_ATTACHMENT' | translate }}</p>
                        <p class="drop-hint">{{ 'FEATURES.AGREEMENTS.UPLOAD_CONTRACT_DRAG_FROP_AREA' | translate }}</p>
                    </ng-template>
                    <input
                        type="file"
                        (click)="resetFileUpload($event)"
                        (change)="uploadFile($event)"
                        [multiple]="false"
                        [disabled]="uploading"
                        style="display: none"
                        #fileInput
                    />
                </div>

                <app-table [loading]="loading" [clickable]="true">
                    <ng-container tbody>
                        <tr *ngFor="let item of files" (click)="view(item)">
                            <td>{{ item.fileName }}</td>
                            <!-- <td>{{ item.fileExtension }}</td> -->
                            <!-- <td class="right">
                                {{ item.created | dateTime: 'yyyy-MM-dd' | replaceEmptyString }}
                            </td> -->
                            <td class="center" style="width: 120px">
                                <button
                                    (click)="download($event, item)"
                                    class="icon"
                                    [ngClass]="{ loading: loadingIds.includes(item.id) }"
                                >
                                    <span class="material-symbols-rounded" aria-label="Download">download</span>
                                </button>
                                <button
                                    *appHasPermissions="[permissions.WriteAgreement]"
                                    (click)="deleteFile(item)"
                                    class="icon"
                                >
                                    <span class="material-symbols-rounded" aria-label="Delete">delete</span>
                                </button>
                            </td>
                        </tr>
                    </ng-container>
                </app-table>
            </app-form-group>
        </app-form-row>
        <app-form-row>
            <app-form-group class="report-container">
                <ngx-extended-pdf-viewer
                    class="pdf-viewer"
                    #pdfViewer
                    [src]="pdfByteArray"
                    height="100vh"
                    useBrowserLocale="true"
                    showSidebar="false"
                >
                </ngx-extended-pdf-viewer>
            </app-form-group>
        </app-form-row>
    </app-form-section>
</form>
